<template>
<el-input
    placeholder=""
    v-model="model[schema.model.split('.')[0]][schema.model.split('.')[1]]"
    :disabled="schema.read">
</el-input>
</template>

<script>
import { abstractField } from "vue-form-generator";
export default {
mixins: [abstractField],

    mounted(){
        if(this.$route.params.dataToUpdate){
        this.model.recettes.recette=this.$route.params.dataToUpdate.recette;
        this.model.client.prenom=this.$route.params.dataToUpdate.client.prenom
        this.model.client.telephone1=this.$route.params.dataToUpdate.client.telephone1
        }
    },


  
};
</script>
